import { DEFAULT_SUCCESS_MESSAGE_TOKEN } from '@common/constants/shop-cart.const';

const DEFAULT_SUCCESS_MESSAGE_PATTERN = new RegExp(`^\\{\\{\\s*${DEFAULT_SUCCESS_MESSAGE_TOKEN}\\s*\\}\\}$`);

/**
 * Tells whether the shop-cart success message still holds the template's placeholder
 * (`{{default_success_message}}`) rather than a text somebody wrote. The value comes out of the
 * WYSIWYG editor, so tags and entities around the token are stripped before comparing.
 */
export function isDefaultSuccessMessage(message: string | null | undefined): boolean {
    if (!message) {
        return false;
    }

    const text = message
        .replace(/<[^>]*>/g, ' ') // strip HTML tags the editor wraps the token in
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    return DEFAULT_SUCCESS_MESSAGE_PATTERN.test(text);
}
